import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconExclamationSmall = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
    ref={ref}
  >
    <path
      d="M6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3333 2.98477 10.3486 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333Z"
      fill="currentColor"
    />
    <path
      d="M6.6665 8.66797C7.05292 8.66807 7.36654 8.98079 7.3667 9.36719C7.3667 9.75372 7.05301 10.0673 6.6665 10.0674C6.2799 10.0674 5.96631 9.75379 5.96631 9.36719C5.96647 8.98072 6.28 8.66797 6.6665 8.66797ZM6.6665 3.30078C7.05301 3.30089 7.3667 3.61444 7.3667 4.00098V6.66699C7.3667 7.05353 7.05301 7.36708 6.6665 7.36719C6.2799 7.36719 5.96631 7.05359 5.96631 6.66699V4.00098C5.96631 3.61438 6.2799 3.30078 6.6665 3.30078Z"
      fill="white"
    />
  </svg>
)

export const IconExclamationSmall = forwardRef(_IconExclamationSmall)
